// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'

// Controller
import suppliesCtrl from 'hfty-ctrl-supplies'

// Exports
export default createReducer(initialState, {
  ...suppliesCtrl.reducers,
})
